import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight, Shield } from 'lucide-react';
import { slideUp } from '../utils/animations';
export function CTASection() {
  return <section className="py-20 md:py-28 lg:py-32 bg-slate-900 relative overflow-hidden" data-id="element-106">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-107">
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-0 right-0 w-[600px] h-[600px] bg-indigo-600/30 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" data-id="element-108" />
        <motion.div animate={{
        scale: [1, 1.1, 1],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-amber-600/20 rounded-full blur-[120px] translate-y-1/3 -translate-x-1/3" data-id="element-109" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-110">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={slideUp} data-id="element-111">
          <motion.div animate={{
          rotate: [0, 5, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-8 border border-white/10" data-id="element-112">
            <Shield className="w-8 h-8 text-amber-300" data-id="element-113" />
          </motion.div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 md:mb-8 tracking-tight" data-id="element-114">
            Protect your <br data-id="element-115" />
            <span className="text-amber-300" data-id="element-116">trademark portfolio</span>
          </h2>

          <p className="text-lg md:text-xl text-slate-300 mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-117">
            Don't let infringement dilute your brand value. Start monitoring
            your trademarks today with Watchdog's free risk scan.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4" data-id="element-118">
            <Button size="lg" variant="white" className="w-full sm:w-auto min-h-[56px] text-lg px-8" icon={<ArrowRight className="w-5 h-5" data-id="element-120" />} data-id="element-119">
              Start Free Trademark Scan
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto min-h-[56px] text-lg px-8 border-2 border-white/30 text-white hover:bg-white hover:text-slate-900 hover:border-white" data-id="element-121">
              Schedule Demo
            </Button>
          </div>

          <p className="mt-6 md:mt-8 text-xs md:text-sm text-slate-400" data-id="element-122">
            No credit card required • SOC2 Compliant • Audit-Ready Reports
          </p>
        </motion.div>
      </div>
    </section>;
}